import { render, staticRenderFns } from "./NovoProdutoSazonal.vue?vue&type=template&id=4d84b0eb"
import script from "./NovoProdutoSazonal.vue?vue&type=script&lang=js"
export * from "./NovoProdutoSazonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports